var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H3.135L6.768 12.36C7.122 12.784 7.064 13.415 6.64 13.768C6.215 14.122 5.585 14.064 5.231 13.64L0.231 7.64C0.192 7.593 0.173 7.538 0.144 7.486C0.12 7.444 0.091 7.408 0.073 7.362C0.028 7.247 0.001 7.126 0.001 7.004C0.001 7.003 0 7.001 0 7C0 6.999 0.001 6.997 0.001 6.996C0.001 6.874 0.028 6.753 0.073 6.638C0.091 6.592 0.12 6.556 0.144 6.514C0.173 6.462 0.192 6.407 0.231 6.36L5.231 0.36C5.43 0.123 5.714 0 6 0C6.226 0 6.453 0.076 6.64 0.232C7.064 0.585 7.122 1.216 6.768 1.64L3.135 6H15C15.552 6 16 6.448 16 7C16 7.552 15.552 8 15 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.180f5e5fb1e14ae273fc4ba938563c43.svg";
export { ForwardRef as ReactComponent };